import { AWFilterList, FilterDomain, UserPreferenceShareResponse } from '@blk/awt-userpreference';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { EnumPrefixConfig, prefixEnumsForAGraph } from '../../utils/ApiUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { userPreferenceApi } from './Base';

const AGRAPH_REQUEST_ENUM_PREFIXES: EnumPrefixConfig[] = [
  { fieldNames: ['operator'], prefix: 'FILTER_OPERATOR_', recursiveFieldPatterns: ['filters'] },
  { fieldNames: ['valueType'], prefix: 'FILTER_VALUE_TYPE_', recursiveFieldPatterns: ['filters'] },
];

export const getSavedDomainFilters = async (domain: FilterDomain, pkg: string) => {
  const path = '/v1/domain-filters';
  const response = await userPreferenceApi.get<AGraphWrappedType<AWFilterList[], 'filters'>>(path, {
    params: { domain, pkg },
  });
  return unwrapAGraphResponse(response, 'filters');
};

export const createSavedDomainFilter = async (filterList: AWFilterList, domain: FilterDomain, pkg: string) => {
  const path = '/v1/domain-filters';
  const payload = isAGraphEnabled() ? prefixEnumsForAGraph(filterList, AGRAPH_REQUEST_ENUM_PREFIXES) : filterList;
  const response = await userPreferenceApi.post<AGraphWrappedType<string, 'result'>>(path, payload, {
    params: { domain, pkg },
  });
  return unwrapAGraphResponse(response, 'result');
};

export const updateSavedDomainFilter = async (
  filterList: AWFilterList,
  id: string,
  domain: FilterDomain,
  pkg: string
) => {
  const payload = isAGraphEnabled() ? prefixEnumsForAGraph(filterList, AGRAPH_REQUEST_ENUM_PREFIXES) : filterList;
  const path = `/v1/domain-filters/${id}`;
  const response = await userPreferenceApi.put<AGraphWrappedType<string, 'result'>>(path, payload, {
    params: { domain, pkg },
  });
  return unwrapAGraphResponse(response, 'result');
};

export const deleteSavedDomainFilter = (id: string, pkg: string, domain: FilterDomain) => {
  const path = `/v1/domain-filters/${id}`;
  return userPreferenceApi.delete(path, { params: { domain, pkg } });
};

export const shareSavedDomainFilterList = (pkg: string, id: string, withUsers: string, domain: FilterDomain) => {
  const path = `/v1/domain-filters/${id}/_share`;
  return userPreferenceApi.post<UserPreferenceShareResponse>(path, isAGraphEnabled() ? {} : undefined, {
    params: { pkg, withUsers, domain },
  });
};
